import { PatchWagesParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchWages/patchWages.type';
import { patchWages } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchWages/patchWagesQueryFunction';
import { useMutation } from '@tanstack/react-query';

export const usePatchWagesQueryOptions = () => {
  return useMutation({
    mutationKey: ['patch_wages'],
    mutationFn: (params: PatchWagesParamsType) => patchWages(params),
  });
};
